import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const lealmanConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Lealman Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Lealman, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_lealman',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Lealman',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Lealman Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide dependable, professional 
     tree care to homeowners and businesses throughout <strong>Lealman</strong>. 
     This dense, established community in central Pinellas County has no shortage 
     of mature trees growing close to homes, fences, driveways, and utility lines. 
     When storm season arrives or a tree simply outgrows its space, our team steps 
     in with the skill and equipment to handle it safely and efficiently.`,

    `We specialize in <strong>hazardous tree removal and targeted trimming</strong> 
     large overhanging limbs near structures, storm damaged trunks, trees crowding 
     utility lines, and canopy overgrowth that creates wind load risk. We work 
     on tight residential lots every day and know how to get the job done cleanly 
     without disrupting your property.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>Lealman</strong> and across <strong>Central Pinellas 
     County</strong> keeping your property safe and your trees well maintained 
     through every season.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Lealman, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Lealman = () => <LocationPage config={lealmanConfig} />;
export default Services_Lealman;
